import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function BridgeSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.2);
  return;
}